import Cookies from 'js-cookie';
import { NewDataAdd, NewDataUpd } from './types';

const API = import.meta.env.VITE_API_BASE_URL;
const today = new Date().toISOString().split('T')[0];

export const fetchGetNews = async () => {
	try {
		const response = await fetch(`${API}/news`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const fetchAddNew = async ({ token, title, text, isHidden }: NewDataAdd) => {
	try {
		const formData = new FormData();

		formData.append('action', 'create');
		formData.append('session_id', token);
		formData.append('title', title);
		formData.append('text', text);
		formData.append('is_hidden', `${isHidden}`);
		formData.append('author_id', Cookies.get('author_id') ?? '');
		formData.append('is_published', today);

		const response = await fetch(`${API}/news/edit`, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const fetchUpdNew = async ({ token, id, title, text, isHidden }: NewDataUpd) => {
	try {
		const formData = new FormData();

		formData.append('action', 'edit');
		formData.append('session_id', token);
		formData.append('id', id);
		formData.append('title', title ?? '');
		formData.append('text', text ?? '');
		formData.append('is_hidden', `${isHidden}`);
		formData.append('author_id', Cookies.get('author_id') || '');
		formData.append('is_published', today);

		const response = await fetch(`${API}/news/edit`, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const fetchDeleteNew = async ({ id, token }: { id: string; token: string }) => {
	try {
		const formData = new FormData();

		formData.append('action', 'delete');
		formData.append('session_id', token);
		formData.append('id', id);

		const response = await fetch(`${API}/news/edit`, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();
			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
